import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { rankListings, bestListingId } from '@/utils/listingPicker';

/**
 * Choix de mon annonce face à l'annonce visée — partagé par la page d'une annonce et la fenêtre « Faire une
 * proposition ». Règles dans utils/listingPicker.js : ordre de pertinence, présélection tant que le membre n'a rien
 * choisi lui-même.
 * @returns {{ ranked, selectedId, selected, choose: (id: string) => void, reset: () => void }}
 */
export function useListingChoice({ meSide, target, listings, proposedIds }) {
  const ranked = useMemo(
    () => rankListings(meSide, target, listings, proposedIds),
    [meSide, target, listings, proposedIds]
  );
  const [selectedId, setSelectedId] = useState('');
  const pickedByUser = useRef(false);

  useEffect(() => {
    if (pickedByUser.current || listings.length === 0) return;
    setSelectedId(bestListingId(ranked));
  }, [ranked]); // eslint-disable-line react-hooks/exhaustive-deps

  const choose = useCallback((id) => { pickedByUser.current = true; setSelectedId(id); }, []);
  const reset = useCallback(() => { pickedByUser.current = false; setSelectedId(''); }, []);

  return { ranked, selectedId, selected: ranked.find((e) => e.listing.id === selectedId) || null, choose, reset };
}
